import { Component, Input, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoRelatorioService } from '../../../services/projeto-relatorio.service';

@Component({
  selector: 'app-projeto-relatorio-4',
  templateUrl: './projeto-relatorio-4.component.html',
  styleUrls: ['./projeto-relatorio-4.component.scss']
})
export class ProjetoRelatorio4Component extends BaseListComponent<any> implements OnInit {
  @Input() report_1_param_1: number = 0;
  @Input() report_3_param_1: number = 0
  @Input() filter_question: number = 0;
  @Input() report_type: number = 1;
  @Input() filter_agency: number[] = [];

  listData:any;

  constructor(
    private projetoRelatorioService: ProjetoRelatorioService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.get();
  }

  sumTotals(items:any):any {
    let result = {};
    result['year1'] = items?.reduce((sum, item) => sum + Number(item.year1), 0) ?? 0;
    result['year2'] = items?.reduce((sum, item) => sum + Number(item.year2), 0) ?? 0;
    result['year3'] = items?.reduce((sum, item) => sum + Number(item.year3), 0) ?? 0;
    return result;
  }

  jsonArray(value: any): string {
    try {
      if(Array.isArray(JSON.parse(value))) {
        const jsonArray = JSON.parse(value);
        return jsonArray.join(', ');
      }
      return value;
    } catch (e) {
      return '';
    }
  }
  
  onPrint(): void {
    // Aumentar timeout para garantir renderização completa antes de imprimir
    setTimeout(() => {
      window.print();
    }, 500);
  }
  
  get() {
    this.loading();
    let filter ={
      report_type: this.report_type,
      filter_agency: this.filter_agency,
      filter_question: this.filter_question
    };
    this.addSub(
      this.projetoRelatorioService.getData(this.report_type, filter).subscribe({
        next: (res) => {
          this.loaded();
          this.listData = res;
          this.cdr.detectChanges();
          setTimeout(() => {
            this.onPrint();
          }, 100);
        },
        error: (erro) => {
          this.msgError(erro?.message);
          this.loaded();
        },
      })
    );
  }

  orgaoNome(agency_id: number): string {
    let agency = this.listData?.agencyList?.find((a: any) => a.num_codigo_pk === agency_id);
    return agency ? agency.str_nome : '';
  }

  comboNome(combo: any, id: number|string, def: string = ''): string {
    let comboItem = combo?.find((a: any) => a.id === id);
    return comboItem ? comboItem.label : def;
  }

  listNome(combo: any, id: number|string, def: string = ''): string {
    if(combo == null) return def;
    let [key, comboItem] = Object.entries(combo)?.find((a: any) => {
      return a[1].id == id
    }) || [];
    return comboItem ? (comboItem as {id:string,title:string})?.title : def;
  }

  execComboType(combo: any, id: number | string, def: string = ''): string {
    if(combo == null) return def;
    let [key, comboItem] = Object.entries(combo)?.find((a: any) => {
      return a[1].id == id
    }) || [];
    return comboItem ? (comboItem as {id:string,label:string})?.label : def;
  }

  arrayComboNome(combo: any, ids: Array<number|string>, def: string = ''): string {
    let comboItem = '';
    ids.forEach(id => {
      comboItem += this.comboNome(combo, id, def) + ', ';
    });
    return comboItem.slice(0, -2);
  }

  selectLocalType(project: any, local: string | number, type: string): string {
    if(local == '1' || local == 1) {
      if(type == 'exec') return this.arrayObjLocalNome(project.cityAdjunctManagers ?? [], 'Nenhuma Cidade executora cadastrada');
      if(type == 'ben') return this.arrayObjLocalNome(project.cityBensAdjunctManagers ?? [], 'Nenhuma Cidade beneficiada cadastrada');
    }
    if(local == '2' || local == 2) {
      if(type == 'exec') return this.arrayObjLocalNome(project.coredeAdjunctManagers ?? [], 'Nenhum Corede executor cadastrado');
      if(type == 'ben') return this.arrayObjLocalNome(project.coredeBensAdjunctManagers ?? [], 'Nenhum Corede beneficiado cadastrado');
    }
    if(local == '3' || local == 3) {
      if(type == 'exec') return this.arrayObjLocalNome(project.rfeAdjunctManagers ?? [], 'Nenhuma Região executora cadastrada');
      if(type == 'ben') return this.arrayObjLocalNome(project.rfbBensAdjunctManagers ?? [], 'Nenhuma Região beneficiada cadastrada');
    }
    return '';
  }

  arrayObjLocalNome(combo: any, def: string = ''): string {
    if(combo.length == 0) return def;
    let comboItem = '';
    combo.forEach(c => {
      comboItem += c.str_nome + ', ';
    });
    return comboItem.slice(0, -2);
  }
}
